/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelMaintenanceDto } from '../models/CancelMaintenanceDto';
import type { CompleteMaintenanceDto } from '../models/CompleteMaintenanceDto';
import type { CreateMaintenanceDto } from '../models/CreateMaintenanceDto';
import type { UpdateMaintenanceDto } from '../models/UpdateMaintenanceDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class MaintenancesService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * Crear un mantenimiento para un activo
   * @returns any Mantenimiento creado exitosamente
   * @throws ApiError
   */
  public maintenancesControllerCreate({
    assetId,
    requestBody,
  }: {
    /**
     * ID del activo
     */
    assetId: string,
    requestBody: CreateMaintenanceDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/assets/{assetId}/maintenances',
      path: {
        'assetId': assetId,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Datos de entrada inválidos`,
        401: `No autorizado`,
        403: `Acceso denegado`,
        404: `Activo no encontrado`,
      },
    });
  }
  /**
   * Listar mantenimientos de un activo
   * @returns any Lista de mantenimientos
   * @throws ApiError
   */
  public maintenancesControllerFindAllByAsset({
    assetId,
    page = 1,
    limit = 10,
    type,
    status,
    technicianId,
    sortBy = 'createdAt',
    sortOrder = 'desc',
  }: {
    /**
     * ID del activo
     */
    assetId: string,
    /**
     * Número de página
     */
    page?: number,
    /**
     * Cantidad de registros por página
     */
    limit?: number,
    /**
     * Filtrar por tipo de mantenimiento
     */
    type?: 'PREVENTIVE' | 'CORRECTIVE' | 'CALIBRATION',
    /**
     * Filtrar por estado
     */
    status?: 'SCHEDULED' | 'IN_PROGRESS' | 'COMPLETED' | 'CANCELLED',
    /**
     * Filtrar por ID de técnico
     */
    technicianId?: string,
    /**
     * Campo para ordenar
     */
    sortBy?: string,
    /**
     * Dirección de ordenamiento
     */
    sortOrder?: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/assets/{assetId}/maintenances',
      path: {
        'assetId': assetId,
      },
      query: {
        'page': page,
        'limit': limit,
        'type': type,
        'status': status,
        'technicianId': technicianId,
        'sortBy': sortBy,
        'sortOrder': sortOrder,
      },
      errors: {
        401: `No autorizado`,
        404: `Activo no encontrado`,
      },
    });
  }
  /**
   * Obtener detalle de un mantenimiento
   * @returns any Detalle del mantenimiento
   * @throws ApiError
   */
  public maintenancesControllerFindOne({
    id,
  }: {
    /**
     * ID del mantenimiento
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/api/maintenances/{id}',
      path: {
        'id': id,
      },
      errors: {
        401: `No autorizado`,
        404: `Mantenimiento no encontrado`,
      },
    });
  }
  /**
   * Actualizar un mantenimiento
   * @returns any Mantenimiento actualizado
   * @throws ApiError
   */
  public maintenancesControllerUpdate({
    id,
    requestBody,
  }: {
    /**
     * ID del mantenimiento
     */
    id: string,
    requestBody: UpdateMaintenanceDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'PATCH',
      url: '/api/maintenances/{id}',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `Datos de entrada inválidos o estado no permite modificación`,
        401: `No autorizado`,
        403: `Acceso denegado`,
        404: `Mantenimiento no encontrado`,
      },
    });
  }
  /**
   * Iniciar un mantenimiento programado
   * @returns any Mantenimiento iniciado
   * @throws ApiError
   */
  public maintenancesControllerStart({
    id,
  }: {
    /**
     * ID del mantenimiento
     */
    id: string,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/maintenances/{id}/start',
      path: {
        'id': id,
      },
      errors: {
        400: `El mantenimiento no está en estado SCHEDULED`,
        401: `No autorizado`,
        403: `Acceso denegado`,
        404: `Mantenimiento no encontrado`,
      },
    });
  }
  /**
   * Completar un mantenimiento en progreso
   * @returns any Mantenimiento completado
   * @throws ApiError
   */
  public maintenancesControllerComplete({
    id,
    requestBody,
  }: {
    /**
     * ID del mantenimiento
     */
    id: string,
    requestBody: CompleteMaintenanceDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/maintenances/{id}/complete',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `El mantenimiento no está en estado IN_PROGRESS`,
        401: `No autorizado`,
        403: `Acceso denegado`,
        404: `Mantenimiento no encontrado`,
      },
    });
  }
  /**
   * Cancelar un mantenimiento
   * @returns any Mantenimiento cancelado
   * @throws ApiError
   */
  public maintenancesControllerCancel({
    id,
    requestBody,
  }: {
    /**
     * ID del mantenimiento
     */
    id: string,
    requestBody: CancelMaintenanceDto,
  }): CancelablePromise<any> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/maintenances/{id}/cancel',
      path: {
        'id': id,
      },
      body: requestBody,
      mediaType: 'application/json',
      errors: {
        400: `El mantenimiento ya está completado o cancelado`,
        401: `No autorizado`,
        403: `Acceso denegado`,
        404: `Mantenimiento no encontrado`,
      },
    });
  }
}
